import './style.css';

import createReactClass from 'create-react-class';
import _ from 'lodash';
import { toJS } from 'mobx';
import React from 'react';
import GeometryMixin from '../../../mixins/geometry-mixin';
import Axis from '../components/axis';
import Bars from '../components/bars';
import Points from '../components/points';
import PolyLine from '../components/polyline';
import Watermark from './controls/watermark';

const LineGraph = createReactClass({
  displayName: 'LineGraph',
  mixins: [GeometryMixin],

  getInitialState() {
    return this.sanatize(this.props);
  },

  getDefaultProps() {
    return {
      points: false,
      data: [],
      axis: 'black',
      ticksX: true,
      ticksY: true,
      mode: {
        x: 'auto',
        y: 'auto'
      },
      keys: {
        x: [],
        y: []
      },
      min: {
        x: Infinity,
        y: Infinity
      },
      max: {
        x: -Infinity,
        y: -Infinity
      }
    };
  },

  UNSAFE_componentWillReceiveProps(next) {
    if (toJS(next) !== toJS(this.props)) return this.setState(this.sanatize(next));
  },

  sanatize(props) {
    let maxValue;
    const data = props.data.map((set) => {
      return (set.values = _.sortBy(set?.values || [], (v) => v.x));
    });

    const values = _.flatten(data);

    if (values.length > 0) {
      maxValue = _.max(values || [], (d) => d.x).y;
    } else {
      maxValue = 'No Value';
    }

    const { min, max } = props;

    const vx = _.map(values, 'x');
    const vy = _.map(values, 'y');

    const limit = {
      x: _.max(vx.concat(max.x)) - _.min(vx.concat(min.x)),
      y: _.max(vy.concat(max.y)) - _.min(vy.concat(min.y))
    };

    if (limit.x === 0) {
      limit.x = 1;
    }
    if (limit.y === 0) {
      limit.y = 1;
    }

    return {
      data,
      limit,
      maxim: maxValue,
      scale: {
        x: 100 / limit.x,
        y: 100 / limit.y
      }
    };
  },

  render() {
    const data = this.props.data.map((set, i) => {
      let lines, points;
      const v = set.values;

      let props = {
        value: v || [],
        colour: set.colour,
        strokeColour: set.borderColour || set.colour,
        scale: this.state.scale,
        isHovered: this.props.hovered === i,
        isFaded: this.props.hovered != null && this.props.hovered !== i,
        hoverWidth: this.props.hoverWidth,
        pointValues: this.props.pointValues,
        hasValues: this.props.mini == null,
        min: this.props.min
      };

      if (this.props.lines && set.values.length > 1) {
        lines = <PolyLine {...props} strokeWidth={1} />;
      }
      if (this.props.points || set.values.length < 2) {
        points = <Points {...props} radius={3} />;
      }
      if (this.props.bars) {
        points = <Bars {...props} radius={3} />;
      }

      return (
        <g key={i} style={{ textAlign: 'center', maxHeight: '100%' }}>
          {lines}
          {points}
        </g>
      );
    });

    const style = { height: '100%', flex: '0 1 auto' };
    style.position = 'relative';
    return (
      <div className={this.props.className} style={style}>
        <Axis
          maxMinY={this.props.maxMinY}
          colour={this.props.axis}
          min={this.props.min}
          max={this.props.max}
          limit={this.state.limit}
          keys={this.props.keys}
          mode={this.props.mode}
          data={this.props.data}
          ticksX={this.props.ticksX}
          ticksY={this.props.ticksY}
          compatability={this.props.compatability}
        >
          {data}
        </Axis>
        <Watermark {...this.props} old={this.state.maxim} />
      </div>
    );
  }
});

export default LineGraph;
